const access = (fn) => {
  try {
    return fn();
  } catch (e) {
    return null;
  }
};

window.access = access;
